<template>
  <div v-rect-loading="loading" class="micro-site-list">
    <TableList
      :listData="listData"
      :tableColumns="tableColumns"
      :actionBtn="actionBtn"
      @create="handleCreate"
    >
      <template #link="{ row }">
        <a class="link" target="_blank" :href="row.link">{{ row.link }}</a>
      </template>
      <template #status="{ row, data }">
        <el-switch :value="data" @change="onEnabledChange($event, row)"></el-switch>
      </template>
    </TableList>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'
import TableList from '@/components/tableList/allowDragSortTable.vue'

export default {
  components: {
    TableList
  },
  data () {
    return {
      loading: false,
      listData: []
    }
  },
  computed: {
    previewLocale () {
      return this.$parent.activePreviewLocale
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t('admin.company.onboarding.label.micrositeName'),
          dataKey: 'name',
          width: 100
        },
        {
          label: this.$t('admin.company.onboarding.label.micrositeUrl'),
          dataKey: 'link',
          slotName: 'link',
          cellClass: 'link-column',
          width: 200
        },
        {
          label: this.$t('admin.company.onboarding.label.micrositeStatus'),
          dataKey: 'status',
          slotName: 'status',
          width: 50
        }
      ]
      return columns
    },
    actionBtn () {
      return {
        edit: {
          isShow: true,
          onclick: this.handleEdit
        }
      }
    }
  },
  created () {
    this.fetchListData()
  },
  methods: {
    ...mapActions('onboardingManagement', ['searchMicroSite', 'updateMicroSite']),
    async fetchListData () {
      this.loading = true
      try {
        const resp = await this.searchMicroSite()
        if (resp && resp.pages) {
          const url = `${window.location.origin}/v-admin/onboarding-management/micro-site/detail/`
          this.listData = _.map(resp.pages, item => {
            return {
              ...item,
              status: item.status === 1,
              link: `${url}${item.url_code}`
            }
          })
        }
      } finally {
        this.loading = false
      }
    },
    handleCreate () {
      this.$router.push({
        path: '/v-admin/onboarding-management/micro-site/add',
        query: {
          tab: 'name'
        }
      })
    },
    handleEdit (rowData) {
      this.$router.push({
        path: `/v-admin/onboarding-management/micro-site/edit/${rowData.id}`,
        query: {
          tab: 'name'
        }
      })
    },
    async onEnabledChange (status, rowData) {
      this.loading = true
      try {
        const statusData = {
          id: rowData.id,
          change_status: status
        }
        const resp = await this.updateMicroSite(statusData)
        if (resp) {
          rowData.status = statusData.change_status
        }
        this.$message.success(this.$t('common.message.optionSuccess'))
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.micro-site-list {
  ::v-deep {
    td {
      &.link-column {
        color: #0096cc;
      }
    }
  }

  .link {
    color: #0096cc;
  }
}
</style>
